// removed by extract-text-webpack-plugin
module.exports = {"container":"jbezSlnwSx5dMve3y3oNS","listVoucher":"_1xubjxCGmRsr7SaafEKzv2","bottomBar":"_12Hq_nZyg5_GcdMHks86tk","viewInside":"_32QHrRn6cFRnc9GToRYVm1","starBottom":"_1VG7uL6C3owv_FRkk4aL-q","textBottom":"_2-9QXsckLSEZZiuJ82s5_9","pointView":"_1SvmrZI__uRoMZtBLcH2k_","pointText":"_16AFzo7uAt_nQnCGmkQTYi","pointExu":"_2YawEYCadDUIkAQGdTeVGa","point":"W8nTBjdd3sha1eH0hoHav","exuPoint":"_3ixMYYFH0MzYViPMMD1UMi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/VoucherFilter.scss
// module id = 1158
// module chunks = 0